import label from "fragments/vendors/label"
import gql from "graphql-tag"

const SEARCH_LABELS_BY_URL = gql`
  ${label}

  query searchLabelsByUrl($searchLabelsByUrlInput: SearchLabelsByUrlInput!) {
    searchLabelsByUrl(searchLabelsByUrlInput: $searchLabelsByUrlInput) {
      ...Label
    }
  }
`

export default SEARCH_LABELS_BY_URL
